// src/features/tidsregistering/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import AbsencePlannerPage from './pages/AbsencePlannerPage';
import AttendancePage from './pages/AttendancePage';
import DayOverviewApprovalsPage from './pages/DayOverviewApprovalsPage';
import MineDagePage from './pages/MineDagePage';
import BalanceManagementPage from './pages/BalanceManagementPage';
import SickLeaveTrackerPage from './pages/SickLeaveTrackerPage';
import PeriodClosingPage from './pages/PeriodClosingPage';
import SalaryExportPage from './pages/SalaryExportPage';
import AnalysePage from './pages/AnalysePage';

export const TidsregistreringRoutes = () => (
  <>
    <Route
      path="tidsregistering/fravaer"
      element={
        <ProtectedRoute requiredScope="tidsregistering:absence:read">
          <AbsencePlannerPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="tidsregistering/fremmøde"
      element={
        <ProtectedRoute requiredScope="tidsregistering:day_overview:read">
          <AttendancePage />
        </ProtectedRoute>
      }
    />
    <Route
      path="tidsregistering/godkendelser"
      element={
        <ProtectedRoute requiredScope="tidsregistering:day_overview:admin_approve">
          <DayOverviewApprovalsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="tidsregistering/mine-dage"
      element={
        <ProtectedRoute requiredScope="tidsregistering:day_overview:read">
          <MineDagePage />
        </ProtectedRoute>
      }
    />
    <Route
      path="tidsregistering/saldi"
      element={
        <ProtectedRoute requiredScope="tidsregistering:absence:admin">
          <BalanceManagementPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="tidsregistering/sygefravaer"
      element={
        <ProtectedRoute requiredScope="tidsregistering:sick_leave:read">
          <SickLeaveTrackerPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="tidsregistering/periodelukning"
      element={
        <ProtectedRoute requiredScope="tidsregistering:closing_period:read">
          <PeriodClosingPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="tidsregistering/loeneksport"
      element={
        <ProtectedRoute requiredScope="tidsregistering:closing_period:read">
          <SalaryExportPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="tidsregistering/analyse"
      element={
        <ProtectedRoute requiredScope="tidsregistering:statistics:read">
          <AnalysePage />
        </ProtectedRoute>
      }
    />
  </>
);
